module.exports = __webpack_public_path__ + "img/vr.0ae54a52.png";